export default __webpack_public_path__ + "static/media/xlaxiata_logo.318e8749.svg";